// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1462f54f","977":"1231ad16"}[chunkId] + ".chunk.js";
};